import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ChatSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.43223 21.3499C7.83362 21.3499 8.1114 21.1394 8.58247 20.7158L11.7756 17.9037H17.9668C20.5631 17.9037 22 16.4274 22 13.8706V6.6833C22 4.1265 20.5631 2.65015 17.9668 2.65015H6.03315C3.43691 2.65015 2 4.11926 2 6.6833V13.8706C2 16.4346 3.43691 17.9037 6.03315 17.9037H6.54168V20.3241C6.54168 20.9522 6.86698 21.3499 7.43223 21.3499ZM7.75916 19.8808V17.2149C7.75916 16.7732 7.59248 16.6065 7.15083 16.6065H6.04039C4.20828 16.6065 3.29719 15.6355 3.29719 13.8634V6.69055C3.29719 4.92285 4.20828 3.9554 6.04039 3.9554H17.9596C19.7772 3.9554 20.7028 4.92285 20.7028 6.69055V13.8634C20.7028 15.6355 19.7772 16.6065 17.9596 16.6065H11.7437C11.2884 16.6065 11.0509 16.6774 10.7281 17.0055L7.75916 19.8808Z"
        fill={color}
      />
      <path
        d="M9.03638 9.99999C9.03638 10.5566 8.58327 11 8.0408 11C7.50227 11 7.03638 10.5475 7.03638 9.99999C7.03638 9.44435 7.49346 9 8.0408 9C8.59208 9 9.03638 9.43526 9.03638 9.99999Z"
        fill={color}
      />
      <path
        d="M12.9514 9.99999C12.9514 10.5566 12.4983 11 11.9558 11C11.4173 11 10.9514 10.5475 10.9514 9.99999C10.9514 9.44435 11.4085 9 11.9558 9C12.5071 9 12.9514 9.43526 12.9514 9.99999Z"
        fill={color}
      />
      <path
        d="M16.8664 9.99999C16.8664 10.5566 16.4133 11 15.8708 11C15.3323 11 14.8664 10.5475 14.8664 9.99999C14.8664 9.44435 15.3235 9 15.8708 9C16.4221 9 16.8664 9.43526 16.8664 9.99999Z"
        fill={color}
      />
    </svg>
  );
};

export { ChatSvg };
